var _path, _path2, _path3, _path4, _path5, _path6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 14C31.5 11.5147 33.5147 9.5 36 9.5C38.4853 9.5 40.5 11.5147 40.5 14C40.5 16.4853 38.4853 18.5 36 18.5C33.5147 18.5 31.5 16.4853 31.5 14Z",
    fill: "white",
    stroke: "#73737B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 34C31.5 31.5147 33.5147 29.5 36 29.5C38.4853 29.5 40.5 31.5147 40.5 34C40.5 36.4853 38.4853 38.5 36 38.5C33.5147 38.5 31.5 36.4853 31.5 34Z",
    fill: "white",
    stroke: "#73737B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 34C19.5 31.5147 21.5147 29.5 24 29.5C26.4853 29.5 28.5 31.5147 28.5 34C28.5 36.4853 26.4853 38.5 24 38.5C21.5147 38.5 19.5 36.4853 19.5 34Z",
    fill: "white",
    stroke: "#73737B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 34C7.5 31.5147 9.51472 29.5 12 29.5C14.4853 29.5 16.5 31.5147 16.5 34C16.5 36.4853 14.4853 38.5 12 38.5C9.51472 38.5 7.5 36.4853 7.5 34Z",
    fill: "white",
    stroke: "#73737B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14C7.5 11.5147 9.51472 9.5 12 9.5C14.4853 9.5 16.5 11.5147 16.5 14C16.5 16.4853 14.4853 18.5 12 18.5C9.51472 18.5 7.5 16.4853 7.5 14Z",
    fill: "white",
    stroke: "#73737B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14C19.5 11.5147 21.5147 9.5 24 9.5C26.4853 9.5 28.5 11.5147 28.5 14C28.5 16.4853 26.4853 18.5 24 18.5C21.5147 18.5 19.5 16.4853 19.5 14Z",
    fill: "white",
    stroke: "#73737B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 14.5,
    width: 39,
    height: 19,
    rx: 1.5,
    fill: "#63C7C9",
    stroke: "#73737B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.8984ac51.svg";
export { ForwardRef as ReactComponent };